import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import Menu from "../components/Menu";
import Swal from "sweetalert2";
import { TranslationContext } from "../contexts/TranslationContext";
import API_BASE_URL from "../apiConfig";
// const API_ENDPOINT = `${API_BASE_URL}/api/$2y$12$V/oiFvdQCTMF`;

const Chatroom = () => {
  const { translations, routes } = useContext(TranslationContext);
  const [chats, setChats] = useState([]);
  const [displayedChats, setDisplayedChats] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showCopiedMessage, setShowCopiedMessage] = useState(false);
  const [visibleCount, setVisibleCount] = useState(3);
  const navigate = useNavigate();
  // useEffect(() => {
  //   const token = localStorage.getItem("token");

  //   if (window.location.pathname === "/chatroom") {
  //     fetch(API_ENDPOINT, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //     }).then(response => response.json()) // Parse response
  //       .then(data => {
  //       })
  //       .catch(error => {
  //       });
  //   }
  // }, []);

  useEffect(() => {
    const fetchChats = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        Swal.fire("Error", "Please log in to view your chats.", "error");
        navigate("/se-connecter");
        return;
      }

      try {
        const response = await fetch(`${API_BASE_URL}/api/chats?locale=${localStorage.getItem('selectedLanguage')}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          setChats(data.data);
          setDisplayedChats(data.data.slice(0, visibleCount)); // Load initial 3 records
        } else {
          Swal.fire("Error", "Failed to load chats.", "error");
        }
      } catch (error) {
        console.error("Error fetching chats:", error);
        Swal.fire(
          "Error",
          "An unexpected error occurred. Please try again.",
          "error"
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchChats();
  }, [navigate, visibleCount]);

  // Load More Function
  const loadMoreChats = () => {
    const newVisibleCount = visibleCount + 3;
    setVisibleCount(newVisibleCount);
    setDisplayedChats(chats.slice(0, newVisibleCount)); // Load next 3 records
  };

  // toggle subscription
  const toggleSubscription = async (userId, isFollowed) => {
    const token = localStorage.getItem("token");
    if (!token) {
      Swal.fire("Error", "Please log in to follow/unfollow users.", "error");
      return;
    }

    if (isFollowed) {
      // Show confirmation alert before unfollowing
      const result = await Swal.fire({
        text: translations.unfollowConfrm,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        cancelButtonText: translations.cancelBtnText,
        confirmButtonText: translations.confirmBtnText,
      });

      if (!result.isConfirmed) {
        return; // Do nothing if the user cancels
      }
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/api/user/toggle-subscription/${userId}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        setChats((prevChats) =>
          prevChats.map((chat) =>
            chat.sender.id === userId
              ? {
                ...chat,
                sender: {
                  ...chat.sender,
                  is_followed_by_auth: !isFollowed,
                  followers_count: isFollowed
                    ? Math.max(0, chat.sender.followers_count - 1)
                    : chat.sender.followers_count + 1,
                },
              }
              : chat
          )
        );

        setDisplayedChats((prevDisplayedChats) =>
          prevDisplayedChats.map((chat) =>
            chat.sender.id === userId
              ? {
                ...chat,
                sender: {
                  ...chat.sender,
                  is_followed_by_auth: !isFollowed,
                  followers_count: isFollowed
                    ? Math.max(0, chat.sender.followers_count - 1)
                    : chat.sender.followers_count + 1,
                },
              }
              : chat
          )
        );

        // Show success alert at the top-right
        Swal.fire({
          position: "top-end",
          icon: "success",
          toast: true,
          title: isFollowed ? translations.unSub : translations.Subcribed,
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          toast: true,
          title: translations.msgError,
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Error toggling subscription:", error);
      Swal.fire("Error", "An unexpected error occurred. Please try again.", "error");
    }
  };


  // copy function
  // const copyWalletKey = (walletKey) => {
  //   navigator.clipboard.writeText(walletKey).then(() => {
  //     setShowCopiedMessage(true);
  //     setTimeout(() => {
  //       setShowCopiedMessage(false);
  //     }, 3000);
  //   });
  // };

  return (
    <>
      <Helmet>
        <title>{translations.chatroom} - O.A.V.L.I.T.E</title>
      </Helmet>
      <div className="navbar-header chat-header container-fluid px-md-5 px-2 pt-2">
        <div></div>
        <Menu />
      </div>

      {/* {showCopiedMessage && (
        <div
          className="key-copied-message-container"
          style={{
            position: "fixed",
            top: "10px",
            width: "max-content",
            margin: "0 auto",
            left: "0",
            right: "0",
            textAlign: "center",
            zIndex: "9999",
          }}
        >
          <span
            className="key-copied-message text-warning"
            style={{ fontSize: "14px" }}
          >
            {translations.keyCopied}
          </span>
        </div>
      )} */}

      <div className="login-wrapper position-relative">
        <div className="container px-5">
          <div className="center-content">
            <div className="minh-chat">
              {isLoading ? (
                <p>{translations.loadingChats}</p>
              ) : displayedChats.length === 0 ? (
                <div className="no-chat">
                  <p className="text-dark text-center">{translations.noChat}</p>
                </div>
              ) : (
                displayedChats.map((chat, index) => (
                  <div className="chat-list mb-4" key={index}>
                    <div className="d-flex justify-content-between">
                      <p className="form-col-lable mb-2 d-flex align-items-center">
                        {chat.sender?.user_name || "Unknown User"}{" "}

                        <span
                          className="premiumBadge text-dark btn bgprimary border-0 badge px-2 ms-2"
                          onClick={() =>
                            toggleSubscription(
                              chat.sender.id,
                              chat.sender.is_followed_by_auth
                            )
                          }
                        >
                          {chat.sender.is_followed_by_auth ? (
                            <>
                              <img
                                src="../images/star.svg"
                                alt="Subscribed"
                                className="star-icon"
                                style={{ width: "40px", marginRight: "5px" }}
                              />
                              {translations.unFollow}
                            </>
                          ) : (
                            translations.follow
                          )}
                        </span>
                        {chat.sender?.subscription_info && (
                          <span className="premiumBadge text-dark badge px-2 ms-4">
                            {translations.premium}
                          </span>
                        )}
                      </p>
                    </div>
                    <p className="text-uppercase mesage-area fw-500 ">{chat.message}</p>
                    {/* <p className="text-center mb-0">
                      {translations.premiumBitcoinTagline1}
                    </p>
                    <p className="text-center">
                      {translations.premiumBitcoinTagline2}
                    </p> */}
                    {/* {chat.sender && chat.sender.user_wallet ? (
                      chat.sender.user_wallet.key ? (
                        <button
                          className="btn btn-light bgprimary border-0 rounded-pill w-100 py-2 mb-2 not-subs fw-600"
                          onClick={() =>
                            copyWalletKey(chat.sender.user_wallet.key)
                          }
                        >
                          <span className="wallet_key">
                            {chat.sender.user_wallet.key}
                          </span>
                          <Link
                            id="copyText"
                            className="copyWalletKey"
                            onClick={() =>
                              copyWalletKey(chat.sender.user_wallet.key)
                            }
                          >
                            <i className="ri-file-copy-line"></i>
                          </Link>
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-light bgprimary py-2 border-0 rounded-pill w-100 mb-2 not-subs fw-600"
                        >
                          Wallet key is not available
                        </button>
                      )
                    ) : (
                      <button
                        type="button"
                        className="btn btn-light bgprimary py-2 border-0 rounded-pill w-100 mb-2 not-subs fw-600"
                      >
                        {translations.notSubscribed}
                      </button>
                    )} */}
                    <h6 className="color-primary text-center">
                      {translations.numberSubscriber}
                    </h6>
                    <p className="color-primary text-center fw-500">
                      {chat.sender.followers_count}
                    </p>

                  </div>
                ))
              )}
              {chats.length > visibleCount && (
                <i
                  className="ri-arrow-down-s-line loadMore"
                  onClick={loadMoreChats}
                ></i>
              )}
            </div>
          </div>
        </div>
      </div>

      <footer className="text-center">
        <p>
          <Link className="color-primary" to={routes.legalNotices}>
            CGU
          </Link>
        </p>
      </footer>
    </>
  );
};

export default Chatroom;
